var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 13,
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 13c-.811 0-4.875-6.094-4.875-8.125A4.89 4.89 0 0 1 6.5 0a4.89 4.89 0 0 1 4.875 4.875C11.375 6.905 7.311 13 6.5 13ZM6.5.811a4.073 4.073 0 0 0-4.061 4.061c0 1.706 3.372 6.906 4.061 6.906.65 0 4.061-5.242 4.061-6.906A4.075 4.075 0 0 0 6.5.812Zm0 6.095a2.012 2.012 0 0 1-2.03-2.031c0-1.136.894-2.03 2.03-2.03 1.136 0 2.03.894 2.03 2.03 0 1.136-.894 2.03-2.03 2.03Zm0-3.25c-.692 0-1.22.527-1.22 1.219 0 .692.528 1.22 1.22 1.22s1.22-.528 1.22-1.22-.528-1.22-1.22-1.22Z",
  fill: "#BAA57E"
})));
export default SvgLocation;